<template>
  <div>
    <div class="product-container">
      <Bread first-name="系统平台" metertype="智慧供热管理平台"></Bread>
      <el-tag effect="dark">智慧供热管理平台</el-tag>
      <div class="sys-synopsis">
        智慧供热管理平台主要用于对卡阀，热表，集中器，远传阀进行管理，并为用户建立信息档案，可完成定时抄表，抄阀门，远程管理集中器等。
      </div>
      <el-tag effect="dark">系统功能简介</el-tag>
      <div class="sys-synopsis">
        <div>
          卡阀档案管理：对客户及卡阀信息进行管理，包含增删改查导入导出等功能 ；
        </div>
        <div>区域管理： 对客户所在的区域进行管理；</div>
        <div>
          热表档案管理： 对客户及热表信息进行管理，包含增删改查导入导出等功能 ；
        </div>
        <div>
          远传阀档案管理：
          对客户及远传阀信息进行管理，包含增删改查导入导出等功能 ；
        </div>
        <div>
          集中器档案管理：
          对客户及远传阀信息进行管理，包含增删改查导入导出等功能 ；
        </div>
        <div>
          系统报表：
          包括操作日志，抄阀日志，抄热表日志，写卡阀日志，错误告警等报表信息；
        </div>
        <div>系统设置： 主要有快捷功能设置，角色管理，操作员管理等功能；</div>
      </div>
      <el-tag effect="dark">系统特点简介</el-tag>
      <div class="sys-synopsis">
        <p>
          安全性：
          数据管理服务器、远程通讯管理服务器和终端用户管理软件分离设计，保证数据安全，完整的权限系统，支持修改各个角色的权限；
        </p>
        <p>便捷性： 快捷操作，支持数据快速填入，便于操作员操作；</p>
        <p>
          扩展性：
          可以根据用户的要求对系统进行定制开发，终端软件远程升级，以满足不同用户的各项新增需求；
        </p>
      </div>
      <div class="system-img">
        <img src="@/svg/hotsys_1.png" />
      </div>
      <div class="system-img">
        <img src="@/svg/hotsys_2.png" />
      </div>
      <div class="system-img">
        <img src="@/svg/hotsys_3.png" />
      </div>
      <div class="system-img">
        <img src="@/svg/hotsys_4.png" />
      </div>
      <div class="system-img">
        <img src="@/svg/hotsys_5.png" />
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scope>
.product-container {
  .el-tag {
    margin-top: 20px;
    height: 40px;
    font-size: 20px;
  }
  .sys-synopsis {
    line-height: 35px;
    letter-spacing: 2px;
    text-indent: 1cm;
    padding: 12px 0;
    font-size: 18px;
  }
  .system-img {
    height: 670px;
    width: 1150px;
    padding-top: 50px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
